
    import "src/app/AppAdmin/Lightning/index.module.scss?farm_css_modules";
    
    export default {"form": `form-933e92b7`}
    